import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
	const getMatches = (query: string): boolean => {
		// Prevents SSR issues
		if (typeof window !== 'undefined') {
			return window.matchMedia(query.replace('@media ', '')).matches;
		}
		return false;
	};

	const [matches, setMatches] = useState<boolean>(getMatches(query));

	useEffect(() => {
		const matchMedia = window.matchMedia(query.replace('@media ', ''));

		const handleChange = () => {
			setMatches(getMatches(query));
		};

		handleChange();

		// Listen matchMedia
		matchMedia.addEventListener('change', handleChange);

		return () => {
			matchMedia.removeEventListener('change', handleChange);
		};
	}, [query]);

	return matches;
}
